import { render, staticRenderFns } from "./AwardEnvirothon2026.vue?vue&type=template&id=6272bd64&scoped=true&"
import script from "./AwardEnvirothon2026.vue?vue&type=script&lang=js&"
export * from "./AwardEnvirothon2026.vue?vue&type=script&lang=js&"
import style0 from "./AwardEnvirothon2026.vue?vue&type=style&index=0&id=6272bd64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272bd64",
  null
  
)

export default component.exports